import { Navbar, Footer } from "@/components/Layout";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { AppleSignInButton } from "@/components/AppleSignInButton";
import { useSeo } from "@/hooks/useSeo";

export default function Login() {
  useSeo({
    title: "Logga in",
    description: "Logga in på ditt TimberNet-konto för att hantera annonser, bud och meddelanden.",
    path: "/logga-in",
  });
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { signIn } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    const { error } = await signIn(email, password);
    setLoading(false);
    if (error) {
      toast.error(error.message === "Invalid login credentials" ? "Fel e-post eller lösenord" : error.message);
    } else {
      toast.success("Inloggad!");
      navigate("/dashboard");
    }
  };

  return (
    <div className="flex min-h-screen flex-col">
      <Navbar />
      <div className="flex flex-1 items-center justify-center px-4 py-12">
        <div className="w-full max-w-sm">
          <h1 className="mb-2 text-center font-display text-2xl font-bold">Logga in</h1>
          <p className="mb-6 text-center text-sm text-muted-foreground">Välkommen tillbaka till TimberNet</p>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <Label htmlFor="email">E-post</Label>
              <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="din@email.se" required />
            </div>
            <div>
              <Label htmlFor="password">Lösenord</Label>
              <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" required />
            </div>
            <Button className="w-full" type="submit" disabled={loading}>
              {loading ? "Loggar in…" : "Logga in"}
            </Button>
          </form>
          <div className="my-4 flex items-center gap-3">
            <div className="h-px flex-1 bg-border" />
            <span className="text-xs uppercase text-muted-foreground">eller</span>
            <div className="h-px flex-1 bg-border" />
          </div>
          <AppleSignInButton className="w-full" label="Logga in med Apple" />
          <p className="mt-4 text-center text-sm text-muted-foreground">
            Har du inget konto? <Link to="/registrera" className="font-medium text-primary hover:underline">Registrera dig</Link>
          </p>
        </div>
      </div>
      <Footer hideOnMobile />
    </div>
  );
}
